import {
  IwsIcon1,
  IwsIcon10,
  IwsIcon11,
  IwsIcon2,
  IwsIcon3,
  IwsIcon4,
  IwsIcon5,
  IwsIcon6,
  IwsIcon7,
  IwsIcon8,
} from 'components/Common/Icon'
import { SubText, TitleH2 } from 'components/Common/Typography'
import { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const IndustriesWeServed: FC<{
  data
}> = ({ data }) => {
  return (
    <section className="industries_we_served">
      <Container data-aos="fade-up">
        <Row className="">
          <Col lg={6}>
            <div>
              <TitleH2 className="text_black mb-4" text={data?.title} />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
              <SubText
                className="mb-5 pt-2"
                text={data?.desc}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col
            lg={12}
            className="mb-2 pt-0 pt-lg-3 d-flex flex-wrap justify-content-start justify-content-xl-between"
          >
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon2 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">Education</div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon1 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">
                Healthcare &amp; Fitness
              </div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon6 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">
                Logistics &amp; Distribution
              </div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon8 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">
                Social Networking
              </div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon4 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">
                Retail &amp; Ecommerce
              </div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon3 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">Real Estate</div>
            </div>

            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon5 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">
                Travel &amp; Hospitality
              </div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="700"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon7 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">
                Food &amp; Restaurant
              </div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon11 className="icon icon-tabler icon-tabler-coin-rupee hvr-icon" />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">Finance</div>
            </div>
            <div
              className="iws_item text-center hvr-icon-bounce"
              data-aos="fade-up"
              data-aos-delay="1000"
            >
              <div className="iws_item_icon d-flex justify-content-center align-items-center">
                <IwsIcon10 />
              </div>
              <div className="text_para text_black mt-2 mt-lg-3">Entertainment</div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default IndustriesWeServed
